<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
<!--    <div class="table-page-search-wrapper">-->
<!--      <a-form layout="inline" @keyup.enter.native="searchQuery">-->
<!--        <a-row :gutter="24">-->

<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="//描述">-->
<!--              <a-input placeholder="请输入//描述" v-model="queryParam.describe"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="//apk、wgt包下载地址或者应用市场地址  安卓应用市场 market://details?id=xxxx 苹果store itms-apps://itunes.apple.com/cn/app/xxxxxx">-->
<!--              <a-input placeholder="请输入//apk、wgt包下载地址或者应用市场地址  安卓应用市场 market://details?id=xxxx 苹果store itms-apps://itunes.apple.com/cn/app/xxxxxx" v-model="queryParam.editionUrl"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--        <template v-if="toggleSearchStatus">-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="//是否强制更新 0代表否 1代表是">-->
<!--              <a-input placeholder="请输入//是否强制更新 0代表否 1代表是" v-model="queryParam.editionForce"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="//0是整包升级（apk或者appstore或者安卓应用市场） 1是wgt升级">-->
<!--              <a-input placeholder="请输入//0是整包升级（apk或者appstore或者安卓应用市场） 1是wgt升级" v-model="queryParam.packageType"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="//是否发行  0否 1是 为了控制上架应用市场审核时不能弹出热更新框">-->
<!--              <a-input placeholder="请输入//是否发行  0否 1是 为了控制上架应用市场审核时不能弹出热更新框" v-model="queryParam.editionIssue"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          </template>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
<!--              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
<!--              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
<!--              <a @click="handleToggleSearch" style="margin-left: 8px">-->
<!--                {{ toggleSearchStatus ? '收起' : '展开' }}-->
<!--                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
<!--              </a>-->
<!--            </span>-->
<!--          </a-col>-->

<!--        </a-row>-->
<!--      </a-form>-->
<!--    </div>-->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('版本更新内容表')">导出</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">导入</a-button>-->
<!--      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <VersionUpdate-modal ref="modalForm" @ok="modalFormOk"></VersionUpdate-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import VersionUpdateModal from './modules/VersionUpdateModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "VersionUpdateList",
    mixins:[JeecgListMixin],
    components: {
      VersionUpdateModal
    },
    data () {
      return {
        description: '版本更新内容表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		   {
            title: '版本更新内容',
            align:"center",
            dataIndex: 'description'
           },
		   {
            title: '下载地址或者应用市场地址',
            align:"center",
            dataIndex: 'editionUrl'
           },
		   {
            title: '是否强制更新',
            align:"center",
            dataIndex: 'editionForce'
           },
		   {
            title: '0是整包升级 1是wgt升级',
            align:"center",
            dataIndex: 'packageType'
           },
		   {
            title: '是否发行',
            align:"center",
            dataIndex: 'editionIssue'
           },
		   {
            title: '版本号',
            align:"center",
            dataIndex: 'editionNumber'
           },
		   {
            title: '版本名称',
            align:"center",
            dataIndex: 'editionName'
           },
		   {
            title: '是否静默更新',
            align:"center",
            dataIndex: 'editionSilence'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/VersionUpdate/list",
          delete: "/VersionUpdate/delete",
          deleteBatch: "/VersionUpdate/deleteBatch",
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>